import React, { useEffect } from "react";
import { useState } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
  Box,
  Divider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import {
  CitySelect,
  CountrySelect,
  StateSelect,
} from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import { colors, fonts, size } from "../ColorFont/color";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { url } from "../ConstUrl/Url";
import { useTranslation } from "react-i18next";
import AddPlotsStep1 from "../screens/FarmerScreen/AddPlotsStep1";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const _OldAddPlots = ({
  setShowCard,
  setShowBtn,
  setAddPlots,
  userData,
  onFileCancel,
  setIsRender,

}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();
  const [category, setCategory] = useState("");
  const [area, setArea] = useState("");
  const [amount, setAmount] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [countryid, setCountryid] = useState(101);
  const [stateid, setstateid] = useState(0);
  const [country, setCountry] = useState("India");
  const [state, setState] = useState("");
  const [taluka, setTaluka] = useState("");
  const [village, setVillage] = useState("");
  const [categories, setCategories] = useState([]); // To store fetched categories
  const [selectedCategory, setSelectedCategory] = useState(""); // Selected category
  const [selectedAreaUnit, setSelectedAreaUnit] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [subCategories, setSubCategories] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [showCountry, setShowCountry] = useState(false);
  const [showSubCat, setShowSubCat] = useState(false);
  useEffect(() => {
    fetch(`${url}/api/get-categories`)
      .then((response) => response.json())
      .then((data) => {
        setCategories(data);
      })
      .catch((error) => console.error(error));
  }, [showCountry, showSubCat]);

  useEffect(() => {
    if (selectedCategory) {
      const category = categories.find(
        (category) => category.categoryType === selectedCategory
      );
      if (category) {
        setSubCategories(category.subCategories);
      }
    }
  }, [selectedCategory]);

  const handleChange = (event) => {
    const { target } = event;
    const value = target.value;
    const name = target.name;
    switch (name) {
      case "village":
        setVillage(value);
        break;
      case "category":
        setCategory(value);
        const selectedCategory = categories.find(
          (categoryData) => categoryData.categoryType === value
        );
        if (selectedCategory) {
          setSubCategories(selectedCategory.subCategories);
        } else {
          setSubCategories([]);
        }
        break;
      case "subCategory":
        setSubCategory(value);

        break;
      case "area":
        setArea(value);
        break;
      case "areaUnit":
        setSelectedAreaUnit(value);
      case "amount":
        setAmount(value);
        break;
      case "contactNumber":
        setContactNumber(value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("country", country);
    formData.append("state", state);
    formData.append("taluka", taluka);
    formData.append("village", village);
    formData.append("area", area);
    formData.append("areaUnit", selectedAreaUnit);
    formData.append("amount", amount);
    formData.append("contactNumber", userData.phoneNumber);
    formData.append("user", userData?._id);
    formData.append("category", selectedCategory);
    formData.append("subCategory", selectedSubCategory);
    selectedFiles.forEach((file) => {
      formData.append("photos", file);
    });

    try {
      const response = await fetch(`${url}/api/plots`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        alert("Plot details submitted successfully!");
      } else {
        const errorData = await response.json();
        alert(`Failed to submit: ${errorData.error}`);
      }
    } catch (error) {
      alert("An error occurred while submitting the form.");
    }
    handleCancelButton();
  };
  const handleCancelButton = () => {
    setAddPlots(false);
    setShowBtn(true);
    setShowCard(true);
    setIsRender(true);
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
  };


  const renderUploadedFiles = () => {
    return selectedFiles.map((file, index) => (
      <Box
        key={index}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
          marginTop: 2,
          padding: 1,
          border: "1px solid #ccc",
          borderRadius: 2,
          position: "relative",
        }}
      >
        <img
          src={URL.createObjectURL(file)}
          alt={`uploaded-preview-${index}`}
          style={{ maxWidth: "150px", maxHeight: "150px", borderRadius: 2 }}
        />
        <Typography sx={{ fontFamily: fonts.poppins }}>{file.name}</Typography>
        <IconButton
          size="small"
          onClick={() => handleRemoveFile(index)}
          sx={{ position: "absolute", right: 0, top: 0, padding: 1 }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    ));
  };

  const handleRemoveFile = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  return (
    <form onSubmit={handleSubmit} method="post" enctype="multipart/form-data">
      <Box>
        <Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              justifyContent: "space-between",
              alignItems: isMobile ? "flex-start" : "center",
              gap: isMobile ? 1 : 0,
            }}
          >
            <Typography
              sx={{
                color: colors.primary_dark,
                fontSize: isMobile ? size.body : size.subtitle,
                fontWeight: 600,
                marginBottom: isMobile ? 0.5 : 1,
                textAlign: isMobile ? "left" : "inherit",
              }}
            >
              {t("plotDetails")}
            </Typography>
            <ClearIcon
              sx={{
                color: colors.red,
                alignSelf: isMobile ? "flex-end" : "center",
                cursor: "pointer",
              }}
              onClick={handleCancelButton}
            />
          </Box>

          <Divider />

          <Box sx={{ marginTop: 2 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: 2,
                marginBottom: 2,
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: size.formLabel,
                    fontWeight: 500,
                    marginBottom: "4px",
                    color: colors.text,
                  }}
                >
                  {t("country")}
                </Typography>
                <CountrySelect
                  onChange={(e) => {
                    setCountry(e.name);
                    setCountryid(e.id);
                  }}
                  placeHolder="Select Country"
                  defaultValue={{ id: 101, name: "India" }}
                  value={"India"}
                  required
                  disabled
                  sx={{ width: isMobile ? "100%" : "auto" }}
                />
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: size.formLabel,
                    fontWeight: 500,
                    marginBottom: "4px",
                    color: colors.text,
                  }}
                >
                  {t("state")}
                </Typography>

                <StateSelect
                  countryid={countryid}
                  onChange={(e) => {
                    setState(e.name);
                    setstateid(e.id);
                  }}
                  placeHolder="Select State"
                  required
                  onClick={() => {
                    setShowCountry(true);
                  }}
                  sx={{ width: isMobile ? "100%" : "auto" }}
                />
              </Box>
              {showCountry && (
                <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                  <Typography
                    sx={{
                      fontFamily: fonts.poppins,
                      fontSize: size.formLabel,
                      fontWeight: 500,
                      marginBottom: "4px",
                      color: colors.text,
                    }}
                  >
                    {t("tahsil")}
                  </Typography>
                  <CitySelect
                    countryid={countryid}
                    stateid={stateid}
                    onChange={(e) => {
                      setTaluka(e.name);
                    }}
                    placeHolder="Select City"
                    required
                    sx={{ width: isMobile ? "100%" : "auto" }}
                  />
                </Box>
              )}
            </Box>

            {/* Village & Crop Selection */}
            <Box
              sx={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: 2,
                marginBottom: 2,
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: size.formLabel,
                    fontWeight: 500,
                    marginBottom: "4px",
                    color: colors.text,
                  }}
                >
                  {t("village")}
                </Typography>
                <TextField
                  placeholder="Enter Village"
                  onChange={(event) => setVillage(event.target.value)}
                  name="village"
                  size="small"
                  required
                  fullWidth
                />
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: size.formLabel,
                    fontWeight: 500,
                    marginBottom: "4px",
                    color: colors.text,
                  }}
                >
                  {t("selectCategory")}
                </Typography>
                <FormControl size="small" fullWidth>
                  <Select
                    value={selectedCategory}
                    onChange={(event) =>
                      setSelectedCategory(event.target.value)
                    }
                    onClick={() => {
                      setShowSubCat(true);
                    }}
                  >
                    {categories.map((category) => (
                      <MenuItem
                        key={category._id}
                        value={category.categoryType}
                      >
                        {category.categoryType}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              {showSubCat && (
                <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                  <Typography
                    sx={{
                      fontFamily: fonts.poppins,
                      fontSize: size.formLabel,
                      fontWeight: 500,
                      marginBottom: "4px",
                      color: colors.text,
                    }}
                  >
                    {t("selectSubCrop")}
                  </Typography>
                  <FormControl size="small" fullWidth>
                    <Select
                      value={selectedSubCategory}
                      onChange={(event) =>
                        setSelectedSubCategory(event.target.value)
                      }
                    >
                      {subCategories.map((subcategory) => (
                        <MenuItem key={subcategory} value={subcategory}>
                          {subcategory}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              )}
            </Box>

            {/* Plot Area, Amount, Contact Number */}
            <Box
              sx={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: 2,
                marginBottom: 2,
              }}
            >
              {/* Plot Area */}
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: size.formLabel,
                    fontWeight: 500,
                    marginBottom: "4px",
                    color: colors.text,
                  }}
                >
                  {t("area")}
                </Typography>
                <FormControl variant="outlined" size="small" fullWidth>
                  <OutlinedInput
                    endAdornment={
                      <FormControl fullWidth size="small">
                        <Select
                          value={selectedAreaUnit}
                          onChange={handleChange}
                          name="areaUnit"
                          displayEmpty
                        >
                          <MenuItem value="" disabled>
                            Area Unit
                          </MenuItem>
                          <MenuItem value="Acre">Acre</MenuItem>
                          <MenuItem value="Hectare">Hectare</MenuItem>
                          <MenuItem value="Guntha">Guntha</MenuItem>
                        </Select>
                      </FormControl>
                    }
                    placeholder={`area ${selectedAreaUnit}`}
                    onChange={handleChange}
                    name="area"
                  />
                </FormControl>
              </Box>

              {/* Amount */}
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: size.formLabel,
                    fontWeight: 500,
                    marginBottom: "4px",
                    color: colors.text,
                  }}
                >
                  {t("amount")}
                </Typography>
                <FormControl size="small" fullWidth>
                  <OutlinedInput
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ fontFamily: fonts.poppins }}
                      >
                        ₹
                      </InputAdornment>
                    }
                    onChange={handleChange}
                    name="amount"
                  />
                </FormControl>
              </Box>

              {/* Contact Number */}
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: size.formLabel,
                    fontWeight: 500,
                    marginBottom: "4px",
                    color: colors.text,
                  }}
                >
                  {t("contactNo")}
                </Typography>
                <TextField
                  size="small"
                  value={userData.phoneNumber}
                  onChange={handleChange}
                  name="contactNumber"
                  fullWidth
                />
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: 2,
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontFamily: fonts.poppins,
                  fontSize: size.formLabel,
                  fontWeight: 500,
                  marginBottom: "4px",
                  color: colors.text,
                }}
              >
                {t("addPhotos")}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Button
                  component="label"
                  variant="contained"
                  startIcon={<CloudUploadIcon />}
                  sx={{
                    backgroundImage: colors.button,
                    padding: isMobile ? "6px 16px" : "8px 20px",
                    fontSize: isMobile ? "14px" : "16px",
                    textTransform: "none",
                    borderRadius: 2,
                    width: isMobile ? "100%" : "auto",
                  }}
                >
                  {t("uploadFiles")}
                  <input
                    type="file"
                    onChange={handleFileChange}
                    multiple
                    accept="image/*"
                    style={{ display: "none" }}
                  />
                </Button>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: 2,
            }}
          >
            {renderUploadedFiles()}
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: 2,
              marginTop: 4,
              marginBottom: 1,
              justifyContent: "center", // Centers the button properly
              alignItems: "center",
            }}
          >
            {!isMobile && <Box sx={{ flex: 1 }}></Box>}

            <Box
              sx={{
                flex: isMobile ? "none" : 1,
                width: isMobile ? "100%" : "auto",
              }}
            >
              <Button
                sx={{
                  backgroundImage: colors.button,
                  width: "100%",
                  padding: isMobile ? "6px 16px" : "8px 20px",
                  fontSize: isMobile ? "14px" : size.formLabel,
                  textTransform: "none",
                  borderRadius: 2,
                }}
                variant="contained"
                onClick={handleSubmit}
              >
                {t("submitPlot")}
              </Button>
            </Box>

            {!isMobile && <Box sx={{ flex: 1 }}></Box>}
          </Box>
        </Box>
      </Box>
    </form>
  );
};

// ===== NEW FIGMA UI =====
const AddPlots = (props) => {
  return <AddPlotsStep1 {...props} />;
};

export default AddPlots;
